// extracted by mini-css-extract-plugin
export var icon = "_ak-3";
export var subtitle = "_ak-2";
export var title = "_ak-1";
export var value = "_ak-0";